import { PERSONA_STATUS_OPTIONS } from '../../helpers/personas/personaStatusLabels'
import { statusOptionsFor } from '../../helpers/statusConfig/resolveStatusDisplay'

/**
 * De statuskeuzelijst van een deelnemer, gedeeld door de deelnemerslijst en de
 * deelnemerpagina. Tegenhanger van `AdressStatusSelect`.
 *
 * Tot 2026-09-09 stond dezelfde `<select>` twee keer uitgeschreven in de code;
 * daardoor was er ook geen plek om de weergavelaag één keer in te hangen.
 *
 * **Geef `display` mee.** Zonder die prop toont de lijst de standaardwoorden en
 * alle vier de statussen — dat is het gedrag van vóór ADR-032 laag D, en het is
 * bewust de terugval: een gemiste aanroeper negeert de instelling in plaats van
 * een lege lijst te tonen. Er is wél geen enkel signaal dat je hem vergeten
 * bent, dus `PersonaStatusSelect.test.jsx` telt de aanroepplekken na.
 * AI-CONTEXT: See docs/pitfalls.md#ui-removed-prop-resurrects-default
 *
 * @param {object} props
 * @param {string} props.value - Huidige `Personas.Status`
 * @param {(e: React.ChangeEvent<HTMLSelectElement>) => void} props.onChange - Krijgt het ruwe event
 * @param {object} [props.display] - Weergavelaag uit `useStatusDisplays().persona`
 * @param {string} [props.docid] - Komt in `data-docid`, voor handlers die het van het event lezen
 * @param {string} [props.id] - `Personas.ID`, komt in `data-id` — de statushistorie logt op ID, niet op docid
 * @param {string} [props.className] - Extra class op de `<select>`
 */
const PersonaStatusSelect = ({ value, onChange, display, docid, id, className }) => {
    // De status die er nú op staat gaat mee, zodat een verborgen status blijft
    // renderen op een deelnemer die hem draagt. Zonder dat toont de lijst
    // blanco en schrijft één wijziging een andere status weg dan er stond —
    // ADR-031 regel 4.
    const options = display
        ? statusOptionsFor(display, value)
        : PERSONA_STATUS_OPTIONS

    return (
        <select
            data-docid={docid}
            data-id={id}
            // De status van vóór de wijziging; de handler legt de wissel vast
            // en leest hem van hetzelfde element af.
            data-status={value || ''}
            value={value || ''}
            onChange={onChange}
            className={className}
        >
            <option value="">-- Selecteer een status --</option>
            {options.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
        </select>
    )
}

export default PersonaStatusSelect
